// Select all elements with the class '.product__variants__item'
var variantItems = document.querySelectorAll('.product__variants__item');

// Add a click event listener to each variant item
variantItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      console.log('this one', e.target);
        var variant = {
            id: this.getAttribute('data-id'), // Assuming the variant ID is stored in a data attribute
            title: this.getAttribute('data-title'), // Similarly for title, adjust if necessary
            inventory_quantity: this.getAttribute('data-quantity'),
            inventory_policy: this.getAttribute('data-policy')
        };

        // Dispatching the event on the body element
        document.body.dispatchEvent(new CustomEvent('variantChange', {
            detail: {
                variant: variant
            },
            bubbles: true,
            cancelable: true
        }));
      console.log('clicked variant')
    //  removeUrlParams();
      
    });
});
// Listen for the 'variantChange' event on the body element
document.body.addEventListener('variantChange', function(e) {
    var variant = e.detail.variant;
    console.log('Variant clicked:', variant);
        
});

document.addEventListener('DOMContentLoaded', (event) => {
    const widthElements = document.querySelectorAll('.product__variants__width');
    const sizeElements = document.querySelectorAll('.product__variants__item');
    const productBtnTextElement = document.querySelector('.product__btn-text');
    const preBox = document.querySelector('.preorderbox');
    var addButton = document.querySelector('.product__btn-text');
    var qtyShow = document.querySelector('.data-qty-info');
    var sizeQty = document.querySelector('.size-qty');
    var submitButton = document.querySelector('.product-form__submit');
    var buttonWrapper = document.querySelector('.product-form__buttons');
    const sizeLabel = document.querySelector('legend.form__label[data-type="size"]');
    var variantId = document.querySelector('.variant_id_input');
    var productHandle = addButton.getAttribute("data-product-handle");
    var isWalletProduct = productHandle && productHandle.includes('wallet');
    
    // Check if product has size variants
    var hasSizeVariants = sizeElements.length > 1;
    var isProductWithoutSizes = isWalletProduct || !hasSizeVariants;

    let lastSelectedSize = document.querySelector('.product__variants__item.current')?.dataset.group;
    
    // Function to handle clicks when no size is selected
    function handleNoSizeClick(e) {
        // Only show size required message if no size is currently selected
        const currentSizeElement = document.querySelector('.product__variants__item.current');
        if (!currentSizeElement && sizeLabel) {
            sizeLabel.classList.add('size-required');
            const titleEl = sizeLabel.querySelector('.form__title');
            if (titleEl) {
                titleEl.textContent = 'Select a size';
            }
        }
    }
    
    function urlParms() {
      const queryParams = new URLSearchParams(window.location.search);
      const variantId = queryParams.get('variant');
      console.log(variantId, 'url variant id');
      if (!variantId) {
          console.log('No variant ID present in the URL.');
          return;
      }  
      document.querySelectorAll('.product__variants__item.current').forEach((element) => {
          element.classList.remove('current');
      });
  
      const variantElement = document.querySelector(`li[data-id="${variantId}"]`);
      if (variantElement) {
          variantElement.classList.add('current');
      }
    }
    /*
    function removeUrlParams() {
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.delete('variant'); // Remove the variant parameter
      // Check if there are any parameters left
      const newQueryString = queryParams.toString();
      const newUrl = newQueryString ? window.location.pathname + '?' + newQueryString : window.location.pathname;
      
      // Update the URL without reloading the page
      history.pushState(null, '', newUrl);
    } */


function highlightVariant() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const variantUrlId = urlSearchParams.get('variant');
  console.log('Variant URL ID:', variantUrlId);
  if (!variantUrlId) {
    console.log('No variant ID provided in URL.');
    return; // Exit if no variant ID is provided
  }

  // Find all variant items on the page
  const variantItems = document.querySelectorAll('.product__variants__item');
  
  // Initially remove 'current' class only from the matching variant ID item
  let targetDataGroup = null;
  variantItems.forEach(item => {
    if (item.dataset.id === variantUrlId) {
      console.log(`Removing 'current' class from item with dataset.id: ${item.dataset.id}`);
      item.classList.remove('current');
      targetDataGroup = item.dataset.group; // Capture the data-group of the matching item
    }
  });

  // Check if targetDataGroup is found; if not, exit the function
  if (!targetDataGroup) {
    console.log('No matching data group found.');
    return;
  }
  
  console.log(`Target data group found: ${targetDataGroup}`);

  // Re-iterate over the items to add 'current' class to a different item with the same data-group
  let newDataId = null;
  for (let item of variantItems) {
    if (item.dataset.group === targetDataGroup && item.dataset.id !== variantUrlId) {
      item.classList.add('current');
      newDataId = item.dataset.id; // Use the data-id of this new matching item
      console.log(`'current' class added to a different item with new data ID: ${newDataId}`);
      break; // Exit the loop after finding the first eligible item
    }
  }

  // Proceed if a new variant ID was identified and it's different from the initial one
  if (newDataId) {
    console.log(newDataId, 'new data id')
      document.querySelectorAll('.product-form__buttons [data-cart-add], .variant_id_input').forEach(element => {
      if (element.tagName === 'INPUT') {
        element.value = newDataId; // Update the hidden input value
      } else {
        element.setAttribute('data-cart-add', newDataId); // Update the data-cart-add attribute
      }
    });

    // Update the 'variant' URL parameter with the new variant ID, preserving other parameters
    urlSearchParams.set('variant', newDataId);
    const newUrl = window.location.pathname + '?' + urlSearchParams.toString();
    window.history.pushState({ path: newUrl }, '', newUrl); // Update the browser URL without reloading the page
    console.log('Browser URL updated.');
  } else {
    console.log('No eligible new variant found to update.');
  }
}


    function updatePreOrderStatus() {
        const currentSizeElement = document.querySelector('.product__variants__item.current');
        console.log(currentSizeElement, 'currentSize landing');

        if (currentSizeElement) {
            const inventoryPolicy = currentSizeElement.getAttribute('data-policy');
            const inventoryQuantity = parseInt(currentSizeElement.getAttribute('data-quantity'), 10);
            var currentVariant = currentSizeElement.dataset.id;
            submitButton.setAttribute('data-cart-add', currentVariant);
            addButton.setAttribute('data-cart-add', currentVariant);
            variantId.value = currentVariant;
            console.log(currentVariant,'currentVariant inner');

            // Update URL with current variant ID
            const urlSearchParams = new URLSearchParams(window.location.search);
            urlSearchParams.set('variant', currentVariant);
            const newUrl = window.location.pathname + '?' + urlSearchParams.toString();
            window.history.pushState({ path: newUrl }, '', newUrl);

            submitButton.classList.remove('product__preorder', 'product__out-stock');
            submitButton.disabled = false;
            addButton.disabled = false;

            // Get button label texts from data attributes
            const addToCartText = addButton.getAttribute('data-add-to-cart-text');
            const preorderText = addButton.getAttribute('data-preorder-text');
            const soldOutText = 'Sold Out'; // optionally: addButton.getAttribute('data-sold-out-text') if you add it in Liquid


            if (inventoryPolicy === 'continue' && inventoryQuantity <= 0) {
                preBox.style.display = 'flex';
                addButton.innerHTML = preorderText;
                qtyShow.innerHTML = inventoryQuantity;
             	sizeQty.style.display = 'none';
                submitButton.disabled = false;
                addButton.disabled = false;
                addButton.classList.remove('no-size');
                submitButton.classList.remove('no-size');
                buttonWrapper.classList.remove('fake-button');
            } else {
                preBox.style.display = 'none';
                addButton.innerHTML = addToCartText;
                qtyShow.innerHTML = inventoryQuantity;
                if (inventoryQuantity <= 0) {
                  // Sold out but no preorder allowed
                  submitButton.classList.add('product__out-stock');
                  submitButton.disabled = true;
                  addButton.disabled = true;
                  addButton.textContent = soldOutText;
              }
            } // else ends

          if ( inventoryQuantity <= 0 || inventoryQuantity >= 10 ){
             	sizeQty.style.display = 'none';
             }
              else {
                sizeQty.style.display = 'flex';
              } // size else ends

        } else {
            // No size selected
            if (!isProductWithoutSizes) {
                // For products with size variants, disable button and show "Select a size"
                submitButton.disabled = true;
                addButton.disabled = true;
                addButton.textContent = 'Select a size';
                addButton.classList.add('no-size');
                submitButton.classList.add('no-size');
                buttonWrapper.classList.add('fake-button');
                
                // Remove any existing click listeners to prevent duplicates
                buttonWrapper.removeEventListener('click', handleNoSizeClick);
                buttonWrapper.addEventListener('click', handleNoSizeClick);
                
                // Clear any variant from URL when no size is selected
                const urlSearchParams = new URLSearchParams(window.location.search);
                urlSearchParams.delete('variant');
                const newUrl = window.location.pathname + (urlSearchParams.toString() ? '?' + urlSearchParams.toString() : '');
                window.history.pushState({ path: newUrl }, '', newUrl);
            } else {
                // For products without size variants (wallets, etc.), enable button and show appropriate text
                submitButton.disabled = false;
                addButton.disabled = false;
                const addToCartText = addButton.getAttribute('data-add-to-cart-text');
                addButton.textContent = addToCartText || 'Add To Cart';
            }
            
            preBox.style.display = 'none';
            sizeQty.style.display = 'none';
        }
    }

    function filterSizes(selectedWidth, hasWidths = true) {
        if (selectedWidth !== 'Wide' && selectedWidth !== 'Standard') {
            return; // Exit if selected width is neither 'Wide' nor 'Standard'
        }
      

        let foundMatchingSize = false;

        sizeElements.forEach(function(sizeElement) {
            const sizeWidth = sizeElement.dataset.width;
            const sizeValue = sizeElement.dataset.group; // Assuming size is stored in data-group

            // For products with widths, only show variants with matching width
            // For products without widths, show all variants (sizeWidth will be undefined)
            const shouldShow = !hasWidths || (sizeWidth === selectedWidth);

            if (shouldShow) {
                sizeElement.style.display = 'flex';
                // Check if this element matches the last selected size
                if (sizeValue === lastSelectedSize) {
                    sizeElement.classList.add('current');
                    updatePreOrderStatus();
                    foundMatchingSize = true;
                }
            } else {
                sizeElement.style.display = 'none';
                sizeElement.classList.remove('current');
            }
        });

        if (!foundMatchingSize && lastSelectedSize) {
            let firstSizeElement = document.querySelector(`.product__variants__item[data-width="${selectedWidth}"]`);
            if (firstSizeElement) {
                firstSizeElement.classList.add('current');
                lastSelectedSize = firstSizeElement.dataset.group;
                console.log(lastSelectedSize, 'last selected firstSize');
                updatePreOrderStatus();
            }
        }
    }

    sizeElements.forEach(function(sizeElement) {
        sizeElement.addEventListener('click', function() {
            sizeElements.forEach(el => el.classList.remove('current'));
            this.classList.add('current');
            lastSelectedSize = this.dataset.group;
            console.log(lastSelectedSize, 'lastselected');
            
            // Skip size-related classes and logic for products without sizes
            if (!isProductWithoutSizes) {
                addButton.classList.remove('no-size');
                submitButton.classList.remove('no-size');
                buttonWrapper.classList.remove('fake-button');
                
                // Remove the click listener since a size is now selected
                buttonWrapper.removeEventListener('click', handleNoSizeClick);
                
                // Reset size label when a size is selected
                if (sizeLabel) {
                    sizeLabel.classList.remove('size-required');
                    const titleEl = sizeLabel.querySelector('.form__title');
                    if (titleEl) {
                        titleEl.textContent = 'Size';
                    }
                }
            }

            updatePreOrderStatus();
        });
    });

    widthElements.forEach(function(widthElement) {
        widthElement.addEventListener('click', function() {
          const selectedWidth = this.dataset.width;
          filterSizes(selectedWidth, hasWidthElements);
        })
    });

    // Initial setup - handle both products with and without widths
    const hasWidthElements = widthElements.length > 0;

    if (hasWidthElements) {
        // Products with widths: show 'Standard' sizes initially (no selection)
        filterSizes('Standard', hasWidthElements);
    } else {
        // Products without widths: show all sizes initially (no selection)
        sizeElements.forEach(sizeElement => {
            sizeElement.style.display = 'flex';
        });
    }

    // No size selected initially - set button appropriately based on product type
    updatePreOrderStatus();

    // Handle URL variant selection on page load
    const urlParams = new URLSearchParams(window.location.search);
    const urlVariantId = urlParams.get('variant');
    if (urlVariantId) {
        const urlVariantElement = document.querySelector(`[data-id="${urlVariantId}"]`);
        if (urlVariantElement) {
            // Remove current selection
            document.querySelectorAll('.product__variants__item.current').forEach(el => el.classList.remove('current'));

            // If product has widths, make sure the correct width is selected
            if (hasWidthElements) {
                const variantWidth = urlVariantElement.dataset.width;
                if (variantWidth) {
                    // Find and click the appropriate width selector
                    const widthSelector = document.querySelector(`.product__variants__width[data-width="${variantWidth}"]`);
                    if (widthSelector) {
                        // Update width selection visuals
                        document.querySelectorAll('.product__variants__width').forEach(w => w.classList.remove('current'));
                        widthSelector.classList.add('current');
                        // Filter sizes for this width (don't call updatePreOrderStatus from here)
                        sizeElements.forEach(function(sizeElement) {
                            const sizeWidth = sizeElement.dataset.width;
                            if (sizeWidth === variantWidth) {
                                sizeElement.style.display = 'flex';
                            } else {
                                sizeElement.style.display = 'none';
                                sizeElement.classList.remove('current');
                            }
                        });
                    }
                }
            }

            // Select the variant from URL
            urlVariantElement.classList.add('current');
            lastSelectedSize = urlVariantElement.dataset.group;

            // Reset size label when a size is selected from URL (skip for products without sizes)
            if (!isProductWithoutSizes && sizeLabel) {
                sizeLabel.classList.remove('size-required');
                const titleEl = sizeLabel.querySelector('.form__title');
                if (titleEl) {
                    titleEl.textContent = 'Size';
                }
                
                // Remove the click listener since a size is now selected
                buttonWrapper.removeEventListener('click', handleNoSizeClick);
            }

            updatePreOrderStatus();
        }
    }
    
    // Select all list items within the 'product-width-wrapper' class
    var widthItems = document.querySelectorAll('.product-width-wrapper .product__variants__width');
    
    // Add a click event listener to each list item
    widthItems.forEach(function(item) {
        item.addEventListener('click', function() {
            // Remove 'current' class from all items
            widthItems.forEach(function(innerItem) {
                innerItem.classList.remove('current');
            });
    
            // Add 'current' class to the clicked item
            this.classList.add('current');
        });
    });
});
